import React from 'react';
import { createRoot } from 'react-dom/client';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { consumeAppSwitchParams } from '@core/utils/appSwitch';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

initializeIcons();

// Strip the v2<->v3 app-switch params before the router reads the URL.
consumeAppSwitchParams();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
